// Rendert das Rekord-Bild direkt auf ein Canvas (ohne html2canvas).
// So gibt es keine Text-/Font-Bugs und das Bild entsteht zuverlässig.

const DISP = "'KH Herz Grotesk','Archivo',sans-serif";
const BODY = "'Open Sans',sans-serif";
const BG = "#fef7f7";
const CARD = "#fffbfa";
const LINE = "#ebd7d3";
const CREME = "#f5ebdd";
const INK = "#111318";
const RED = "#e30620";
const GRAU = "#6e6e73";

function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function setSpacing(ctx, val) {
  try {
    ctx.letterSpacing = val;
  } catch (e) {}
}

export async function renderShareCard(result) {
  const { score, belt, name, levelLabel } = result;
  const W = 360;
  const H = 640;
  const S = 2;
  const canvas = document.createElement("canvas");
  canvas.width = W * S;
  canvas.height = H * S;
  const ctx = canvas.getContext("2d");
  ctx.scale(S, S);
  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";

  try {
    await document.fonts.ready;
  } catch (e) {
    console.warn("Schriften nicht bereit:", e);
  }
  try {
    await Promise.all([
      document.fonts.load("900 82px 'KH Herz Grotesk'"),
      document.fonts.load("800 30px 'KH Herz Grotesk'"),
      document.fonts.load("700 12px 'KH Herz Grotesk'"),
      document.fonts.load("600 10px 'Open Sans'"),
    ]);
  } catch (e) {
    console.warn("Schrift konnte nicht geladen werden, nutze Fallback:", e);
  }

  // Hintergrund + roter Streifen
  ctx.fillStyle = BG;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = RED;
  ctx.fillRect(0, 0, W, 10);

  // Kopf (Logo + Marke), zentriert
  const logo = await loadImage("/logo.png");
  ctx.font = `800 14px ${DISP}`;
  const brand = "KAMPFKUNST HERZ®";
  const brandW = ctx.measureText(brand).width;
  const groupW = 40 + 10 + brandW;
  const gx = 180 - groupW / 2;
  const hTop = 42;
  if (logo) ctx.drawImage(logo, gx, hTop, 40, 40);
  ctx.textAlign = "left";
  ctx.fillStyle = INK;
  ctx.font = `800 14px ${DISP}`;
  ctx.fillText(brand, gx + 50, hTop + 17);
  ctx.fillStyle = GRAU;
  ctx.font = `600 9.5px ${BODY}`;
  ctx.fillText("Die Lebensschule für Kinder", gx + 50, hTop + 31);

  // Titel
  ctx.textAlign = "center";
  ctx.fillStyle = RED;
  ctx.font = `900 30px ${DISP}`;
  ctx.fillText("ZIEH DURCH!", 180, 134);
  ctx.fillText("DRÜCK DRAUF!", 180, 164);

  // Ergebnis-Karte
  const cardTop = 194;
  const cardLeft = 28;
  const cardW = 304;
  const cardH = 250;
  ctx.fillStyle = CARD;
  roundRect(ctx, cardLeft, cardTop, cardW, cardH, 22);
  ctx.fill();
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = LINE;
  ctx.stroke();

  // Name-Zeile
  ctx.fillStyle = GRAU;
  ctx.font = `700 11px ${DISP}`;
  setSpacing(ctx, "1.4px");
  ctx.fillText(`${(name || "Gast").toUpperCase()} HAT GESCHAFFT`, 180, cardTop + 36);
  setSpacing(ctx, "0px");

  // Punktzahl
  ctx.fillStyle = RED;
  ctx.font = `900 82px ${DISP}`;
  ctx.fillText(String(score), 180, cardTop + 120);

  // "PUNKTE"
  ctx.fillStyle = GRAU;
  ctx.font = `700 12px ${DISP}`;
  setSpacing(ctx, "1.6px");
  ctx.fillText("PUNKTE", 180, cardTop + 150);
  setSpacing(ctx, "0px");

  // Trennlinie
  ctx.strokeStyle = LINE;
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(cardLeft + 34, cardTop + 176);
  ctx.lineTo(cardLeft + cardW - 34, cardTop + 176);
  ctx.stroke();

  // Gürtel- und Level-Pille
  const beltText = `GÜRTEL ${(belt.label || "").toUpperCase()}`;
  const levelText = `LEVEL ${(levelLabel || "").toUpperCase()}`;
  ctx.font = `800 15px ${DISP}`;
  const bTextW = ctx.measureText(beltText).width;
  ctx.font = `700 13px ${DISP}`;
  const lTextW = ctx.measureText(levelText).width;
  const gap = 10;
  const pillH = 30;
  const bPillW = bTextW + 32;
  const lPillW = lTextW + 28;
  const totalW = bPillW + gap + lPillW;
  let px = 180 - totalW / 2;
  const pillY = cardTop + 196;

  // Gürtel-Pille
  ctx.fillStyle = belt.color;
  roundRect(ctx, px, pillY, bPillW, pillH, 9);
  ctx.fill();
  ctx.lineWidth = 2.5;
  ctx.strokeStyle = belt.ring;
  roundRect(ctx, px + 1.5, pillY + 1.5, bPillW - 3, pillH - 3, 7.5);
  ctx.stroke();
  ctx.fillStyle = belt.textColor;
  ctx.font = `800 15px ${DISP}`;
  ctx.textBaseline = "middle";
  ctx.fillText(beltText, px + bPillW / 2, pillY + pillH / 2 + 1);

  // Level-Pille
  const lx = px + bPillW + gap;
  ctx.fillStyle = CREME;
  roundRect(ctx, lx, pillY, lPillW, pillH, 9);
  ctx.fill();
  ctx.fillStyle = INK;
  ctx.font = `700 13px ${DISP}`;
  ctx.fillText(levelText, lx + lPillW / 2, pillY + pillH / 2 + 1);
  ctx.textBaseline = "alphabetic";

  // Fuß
  ctx.fillStyle = RED;
  ctx.font = `800 15px ${DISP}`;
  ctx.fillText("SPIELST DU MIT?", 180, 598);
  ctx.fillStyle = GRAU;
  ctx.font = `700 10px ${DISP}`;
  setSpacing(ctx, "2.4px");
  ctx.fillText("LERNEN · LIEBEN · LEBEN", 180, 616);
  setSpacing(ctx, "0px");

  return canvas.toDataURL("image/png");
}

export function dataURLToFile(dataUrl, name) {
  const [head, b64] = dataUrl.split(",");
  const mime = (head.match(/:(.*?);/) || [null, "image/png"])[1];
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new File([arr], name, { type: mime });
}
